import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { FiEdit3 } from "react-icons/fi";
import logo from "../assets/LOGO_PNG.png";

export default function Sidebar({ onNewConversation }) {
    const { instance, accounts } = useMsal();
    const user = accounts[0];
    const name = user?.name?.split(" - ")[0] || "Usuário";
    const [photo, setPhoto] = useState(null);
    const [status, setStatus] = useState("Offline");

    useEffect(() => {
        if (!user) return undefined;
        let imageUrl;
        let cancelled = false;

        async function loadProfile() {
            try {
                const response = await instance.acquireTokenSilent({
                    scopes: ["User.Read", "Presence.Read"],
                    account: user,
                });

                const [photoResponse, presenceResponse] = await Promise.all([
                    fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
                        headers: { Authorization: `Bearer ${response.accessToken}` },
                    }),
                    fetch("https://graph.microsoft.com/v1.0/me/presence", {
                        headers: { Authorization: `Bearer ${response.accessToken}` },
                    }),
                ]);

                if (photoResponse.ok && !cancelled) {
                    imageUrl = URL.createObjectURL(await photoResponse.blob());
                    setPhoto(imageUrl);
                }

                if (presenceResponse.ok && !cancelled) {
                    const presence = await presenceResponse.json();
                    setStatus(presence.availability || "Offline");
                }
            } catch (error) {
                console.error("Erro ao carregar perfil:", error);
            }
        }

        loadProfile();
        return () => {
            cancelled = true;
            if (imageUrl) URL.revokeObjectURL(imageUrl);
        };
    }, [instance, user]);

    return (
        <aside className="sidebar">
            <div className="sidebar-top">
                <div className="logo-container">
                    <img src={logo} alt="Fontes & Advogados Associados" className="logo" />
                </div>
                <button className="new-chat" onClick={onNewConversation}>
                    <FiEdit3 aria-hidden="true" />
                    <span>Nova conversa</span>
                </button>
            </div>

            <div className="sidebar-copy">
                <span className="sidebar-copy-label">Assistente jurídico</span>
                <p>Converse com o Bartolomeu sobre documentos e dúvidas do dia a dia.</p>
            </div>

            <div className="user-card">
                <div className="user-avatar">
                    {photo ? <img src={photo} alt="" /> : <span>{name.charAt(0).toUpperCase()}</span>}
                    <span className={`status ${status}`} title={status} />
                </div>
                <div className="user-info">
                    <div className="user-name">{name}</div>
                    <div className="user-email">{user?.username}</div>
                </div>
            </div>
        </aside>
    );
}
